import { themeVars } from '@prose-ui/theme.css';

import { useState } from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';

import styled from '@emotion/styled';

import Spacer from 'Components/Spacer';
import Typography from 'Components/Typography';

import { productsSlugs } from 'constants/products';

import { srcOrNextImageProp } from 'PropTypes/imageProps';

import badgeAwardSkincare from 'assets/images/badge-award-skincare.png';

const CardContainer = styled(Link)`
  position: relative;
  display: block;
  color: inherit;
  border: 1px solid;
  margin: 0 ${props => props.margin}px;
  background: ${props => props.theme.palette.common.white.light};
`;

const CardInfoContainer = styled.div`
  padding: ${props => props.theme.spacing.s40}px;
  ${props => props.theme.breakpoints.match('xs')} {
    height: 240px;
  }
  ${props => props.theme.breakpoints.match('sm')} {
    height: 240px;
  }
`;
const CardTextContainer = styled.div`
  height: 100px;
  ${props => props.theme.breakpoints.match('sm')} {
    margin-bottom: 40px;
  }
`;

const IsNewChip = styled(Typography)`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${props => props.theme.spacing.s24}px;
  background: ${props => props.theme.palette.common.white.light};
  top: ${props => props.theme.spacing.s24}px;
  left: ${props => props.theme.spacing.s24}px;
  padding: 0 ${props => props.theme.spacing.s16}px;
`;

const Cta = styled(Typography)`
  &:hover {
    text-decoration: underline;
  }
`;

const ImageContainer = styled.div`
  width: 100%;
  height: 350px;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-bottom: 1px solid;
`;
const ImageContainerLabel = styled.div`
  position: absolute;
  width: 90px;
  height: 90px;
  top: ${themeVars.spacing['4x']};
  right: ${themeVars.spacing['4x']};
`;

const ImageAwardLabel = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const ProductCard = ({ dataFrom, dataClick, product, isNew, margin }) => {
  const {
    label,
    capacity,
    priceWithSubscription,
    productSquaredPictureHover,
    productSquaredPicture,
    productPageUrl,
    slug,
  } = product;
  const [isHovered, setHovered] = useState(false);
  return (
    <CardContainer
      data-click={dataClick}
      data-from={dataFrom}
      margin={margin}
      onMouseEnter={() => {
        setHovered(true);
      }}
      onMouseLeave={() => setHovered(false)}
      to={productPageUrl}
    >
      {isNew && (
        <IsNewChip italic variant="p3">
          New
        </IsNewChip>
      )}

      {slug === productsSlugs.MOISTURIZER && (
        <ImageContainerLabel>
          <ImageAwardLabel alt={`${label}-label-award`} src={badgeAwardSkincare.src} />
        </ImageContainerLabel>
      )}

      <ImageContainer>
        <Image
          alt={`${label}-picture`}
          src={(isHovered ? productSquaredPictureHover : productSquaredPicture).src}
        />
      </ImageContainer>
      <CardInfoContainer>
        <CardTextContainer>
          <Typography variant="h2">Custom {label}</Typography>
          <Spacer size={8} />
          <Typography>{`From $${priceWithSubscription.toFixed(2)}, ${capacity}`}</Typography>
        </CardTextContainer>
        <Cta align="left" color="noir" underline variant="p2">
          Learn More
        </Cta>
      </CardInfoContainer>
    </CardContainer>
  );
};

ProductCard.defaultProps = {
  isNew: false,
  margin: null,
  dataFrom: null,
  dataClick: null,
};

ProductCard.propTypes = {
  margin: PropTypes.number,
  dataFrom: PropTypes.string,
  dataClick: PropTypes.string,
  isNew: PropTypes.bool,
  product: PropTypes.shape({
    label: PropTypes.string,
    capacity: PropTypes.string,
    priceWithSubscription: PropTypes.number,
    productSquaredPicture: srcOrNextImageProp,
    productSquaredPictureHover: srcOrNextImageProp,
    productPageUrl: PropTypes.string,
    slug: PropTypes.string,
  }).isRequired,
};

export default ProductCard;
